module.exports = __webpack_public_path__ + "static/fonts/iconfont.8fdcb1f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/openSurvey/theme/fonts/iconfont.woff
// module id = UZPB
// module chunks = 1